import localforage from "localforage";
import { useEffect, useState } from "react";

export function useLocalForage<T>(
	key: string,
	defaultValue: T,
): [T, (value: T | ((prev: T) => T)) => void] {
	const [storedValue, setStoredValue] = useState<T>(defaultValue);

	useEffect(() => {
		localforage
			.getItem<T>(key)
			.then((val) => {
				if (val !== null) setStoredValue(val);
			})
			.catch(console.error);
	}, [key]);

	const setValue = (value: T | ((prev: T) => T)) => {
		setStoredValue((prev) => {
			const next =
				typeof value === "function" ? (value as (prev: T) => T)(prev) : value;
			localforage.setItem(key, next).catch(console.error);
			return next;
		});
	};

	return [storedValue, setValue];
}
